import { SettingsParser } from "../../settings-parser";
import { ChannelConfigurationPlotSettings } from "../../../settings/view-objects/plot/channel-configuration-plot-settings";
import { getItemByField, ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelConfigurationPlotSettingsParser extends SettingsParser {
  constructor(signalParser, isolineParser, plotContentParserMap) {
    super();
    this.parsedFieldNames = ["name_configuration", "signals", "signal", "isolines", "isoline", "plotContent"];
    this.signalParser = signalParser;
    this.isolineParser = isolineParser;
    this.plotContentParserMap = plotContentParserMap;
  }

  static createSettings(settings, defaultSettings, signalParser, isolineParser, plotContentParserMap) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      name_configuration: settings.name_configuration
    };
    if (settings.signals !== undefined && signalParser !== undefined) {
      parsedSettings.signals = [];
      let signalDefaultSettings = defaultSettings?.signal;
      for (let signalIndex = 0; signalIndex < settings.signals.length; signalIndex++) {
        let signalSettings = signalParser.parse(settings.signals[signalIndex], signalDefaultSettings);
        if (signalSettings !== undefined) {
          parsedSettings.signals.push(signalSettings);
        }
      }
    }
    if (settings.isolines !== undefined && isolineParser !== undefined) {
      parsedSettings.isolines = [];
      let isolineDefaultSettings = defaultSettings?.isoline;
      for (let isolineIndex = 0; isolineIndex < settings.isolines.length; isolineIndex++) {
        let isolineSettings = isolineParser.parse(settings.isolines[isolineIndex], isolineDefaultSettings);
        if (isolineSettings !== undefined) {
          parsedSettings.isolines.push(isolineSettings);
        }
      }
    }
    let plotContentNames = [];
    if (settings.plotContent !== undefined) {
      parsedSettings.plotContent = {};
      for (let contentIndex = 0; contentIndex < settings.plotContent.length; contentIndex++) {
        let plotContentSettings = settings.plotContent[contentIndex];
        let plotContentParser = plotContentParserMap.get(plotContentSettings.name);
        if (plotContentParser === undefined) {
          plotContentParser = plotContentParserMap.get("_default");
        }
        if (plotContentParser !== undefined) {
          let defaultPlotContentSettings = getItemByField("name", plotContentSettings.name, defaultSettings?.plotContent);
          let parsedPlotContent = plotContentParser.parse(plotContentSettings, defaultPlotContentSettings);
          if (parsedPlotContent !== undefined) {
            let plotContentKey = parsedPlotContent.type != "graphic" ? parsedPlotContent.type : parsedPlotContent.place;
            if (parsedSettings.plotContent[plotContentKey] === undefined) {
              parsedSettings.plotContent[plotContentKey] = [];
            }
            parsedSettings.plotContent[plotContentKey].push(parsedPlotContent);
          }
        }
      }
    }
    if (defaultSettings?.plotContent !== undefined) {
      for (let contentIndex = 0; contentIndex < defaultSettings.plotContent.length; contentIndex++) {
        let defaultContentSettings = defaultSettings.plotContent[contentIndex];
        if (!plotContentNames.includes(defaultContentSettings.name)) {
          let plotContentKey = defaultContentSettings.type != "graphic" ? defaultContentSettings.type : defaultContentSettings.place;
          if (parsedSettings.plotContent[plotContentKey] === undefined) {
            parsedSettings.plotContent[plotContentKey] = [];
          }
          parsedSettings.plotContent[plotContentKey].push(ObjectCreator.deepCopy(defaultContentSettings));
        }
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ChannelConfigurationPlotSettingsParser.createSettings(
      settings,
      defaultSettings,
      this.signalParser,
      this.isolineParser,
      this.plotContentParserMap
    );
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ChannelConfigurationPlotSettings(parsedSettings);
  }
}
